<template>
  <div>
    <h3>{{ $t('building-type-analysis') }}</h3>
    <h4>{{ $t('permit-activity-by-building-type') }}</h4>
    <div class="table-responsive">
      <table class="table table-striped table-bordered">
        <thead>
        <tr>
          <th scope="col" rowspan="3"><h5 class="mb-0">{{ $t('building-type') }}</h5></th>
          <th scope="col" colspan="6">{{ $t('value-in-thousands') }}</th>
          <th scope="col" colspan="6">
            {{ $t('number-permits-issued') }}
          </th>
        </tr>
        <tr>
          <th scope="col" colspan="3">{{ $t('month') }}</th>
          <th scope="col" colspan="3">{{ $t('year-to-date') }}</th>
          <th scope="col" colspan="3">{{ $t('month') }}</th>
          <th scope="col" colspan="3">{{ $t('year-to-date') }}</th>
        </tr>
        <tr>
          <th scope="col">
            {{ curYear }}
          </th>
          <th scope="col">
            {{ lastYear }}
          </th>
          <th scope="col">{{ $t('change') }}</th>
          <th scope="col">
            {{ curYear }}
          </th>
          <th scope="col">
            {{ lastYear }}
          </th>
          <th scope="col">{{ $t('change') }}</th>
          <th scope="col">
            {{ curYear }}
          </th>
          <th scope="col">
            {{ lastYear }}
          </th>
          <th scope="col">{{ $t('change') }}</th>
          <th scope="col">
            {{ curYear }}
          </th>
          <th scope="col">
            {{ lastYear }}
          </th>
          <th scope="col">{{ $t('change') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th scope="row"><h5 class="mb-0">{{ $t('residential') }}</h5></th>
          <td colspan="12" />
        </tr>
        <tr v-for="(res, i) in residentials" :key="i + 'res'">
          <td scope="row">{{ res.building_type }}</td>
          <td>
            {{ res.curr_mon_value | currency($LANG) }}
          </td>
          <td>
            {{ res.prev_mon_value | currency($LANG) }}
          </td>
          <td>{{ res.mon_value_change_pct | percent($LANG) }}</td>
          <td>
            {{ res.curr_ytd_value | currency($LANG) }}
          </td>
          <td>
            {{ res.prev_ytd_value | currency($LANG) }}
          </td>
          <td>{{ res.prev_ytd_value_change_pct | percent($LANG) }}</td>
          <td>{{ res.curr_mon_permit_total }}</td>
          <td>{{ res.prev_mon_permit_total }}</td>
          <td>{{ res.mon_permit_total_change_pct | percent($LANG) }}</td>
          <td>{{ res.curr_ytd_permit_total }}</td>
          <td>{{ res.prev_ytd_permit_total }}</td>
          <td>{{ res.ytd_permit_total_change_pct | percent($LANG) }}</td>
        </tr>
        <tr>
          <th scope="row">{{ $t('total-residential') }}</th>
          <td>
            {{ totalRes.curr_mon_value | currency($LANG) }}
          </td>
          <td>
            {{ totalRes.prev_mon_value | currency($LANG) }}
          </td>
          <td>{{ totalRes.mon_value_change_pct | percent($LANG) }}</td>
          <td>
            {{ totalRes.curr_ytd_value | currency($LANG) }}
          </td>
          <td>
            {{ totalRes.prev_ytd_value | currency($LANG) }}
          </td>
          <td>{{ totalRes.prev_ytd_value_change_pct | percent($LANG) }}</td>
          <td>{{ totalRes.curr_mon_permit_total }}</td>
          <td>{{ totalRes.prev_mon_permit_total }}</td>
          <td>
            {{ totalRes.mon_permit_total_change_pct | percent($LANG) }}
          </td>
          <td>{{ totalRes.curr_ytd_permit_total }}</td>
          <td>{{ totalRes.prev_ytd_permit_total }}</td>
          <td>
            {{ totalRes.ytd_permit_total_change_pct | percent($LANG) }}
          </td>
        </tr>
        <tr>
          <th scope="row"><h5 class="mb-0">{{ $t('non-residential') }}</h5></th>
          <td colspan="12" />
        </tr>
        <tr v-for="(res, i) in nonResidentials" :key="i + 'nonres'">
          <td scope="row">{{ res.building_type }}</td>
          <td>
            {{ res.curr_mon_value | currency($LANG) }}
          </td>
          <td>
            {{ res.prev_mon_value | currency($LANG) }}
          </td>
          <td>{{ res.mon_value_change_pct | percent($LANG) }}</td>
          <td>
            {{ res.curr_ytd_value | currency($LANG) }}
          </td>
          <td>
            {{ res.prev_ytd_value | currency($LANG) }}
          </td>
          <td>{{ res.prev_ytd_value_change_pct | percent($LANG) }}</td>
          <td>{{ res.curr_mon_permit_total }}</td>
          <td>{{ res.prev_mon_permit_total }}</td>
          <td>{{ res.mon_permit_total_change_pct | percent($LANG) }}</td>
          <td>{{ res.curr_ytd_permit_total }}</td>
          <td>{{ res.prev_ytd_permit_total }}</td>
          <td>{{ res.ytd_permit_total_change_pct | percent($LANG) }}</td>
        </tr>
        <tr>
          <th scope="row">{{ $t('total-non-residential') }}</th>
          <td>
            {{ totalNonRes.curr_mon_value | currency($LANG) }}
          </td>
          <td>
            {{ totalNonRes.prev_mon_value | currency($LANG) }}
          </td>
          <td>{{ totalNonRes.mon_value_change_pct | percent($LANG) }}</td>
          <td>
            {{ totalNonRes.curr_ytd_value | currency($LANG) }}
          </td>
          <td>
            {{ totalNonRes.prev_ytd_value | currency($LANG) }}
          </td>
          <td>
            {{ totalNonRes.prev_ytd_value_change_pct | percent($LANG) }}
          </td>
          <td>{{ totalNonRes.curr_mon_permit_total }}</td>
          <td>{{ totalNonRes.prev_mon_permit_total }}</td>
          <td>
            {{ totalNonRes.mon_permit_total_change_pct | percent($LANG) }}
          </td>
          <td>{{ totalNonRes.curr_ytd_permit_total }}</td>
          <td>{{ totalNonRes.prev_ytd_permit_total }}</td>
          <td>
            {{ totalNonRes.ytd_permit_total_change_pct | percent($LANG) }}
          </td>
        </tr>
        <tr>
          <th scope="row"><h5 class="mb-0">{{ $t('total') }}</h5></th>
          <td>
            {{ total.curr_mon_value | currency($LANG) }}
          </td>
          <td>
            {{ total.prev_mon_value | currency($LANG) }}
          </td>
          <td>{{ total.mon_value_change_pct | percent($LANG) }}</td>
          <td>{{ total.curr_ytd_value | currency($LANG) }}</td>
          <td>{{ total.prev_ytd_value | currency($LANG) }}</td>
          <td>{{ total.prev_ytd_value_change_pct | percent($LANG) }}</td>
          <td>{{ total.curr_mon_permit_total }}</td>
          <td>{{ total.prev_mon_permit_total }}</td>
          <td>{{ total.mon_permit_total_change_pct | percent($LANG) }}</td>
          <td>{{ total.curr_ytd_permit_total }}</td>
          <td>{{ total.prev_ytd_permit_total }}</td>
          <td>{{ total.ytd_permit_total_change_pct | percent($LANG) }}</td>
        </tr>
      </tbody>
    </table>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: "ActivityTable1",

  props: {
    curYear: String,
    startDate: String,
    endDate: String,
  },

  data() {
    return {
      response03: [],
      response04: [],
      response05: [],
    }
  },

  created() {
    this.fetchData();
  },

  watch: {
    endDate() {
      this.fetchData();
    }
  },

  methods: {
    fetchData() {
      const startDate = this.startDate;
      const endDate = this.endDate;
     // Permit Activity by Building Type
      // By Building Type
      const request03 = axios.get(
        `${this.$PERMIT_API}?$select=residential_category, building_type, sum(case(issue_date='${endDate}',declared_construction_value,true,0)) as curr_mon_value, sum(case(issue_date='${startDate}',declared_construction_value,true,0)) as prev_mon_value, case(sum(case(issue_date='${startDate}',declared_construction_value,true,0))=0,0,true,round(100*(sum(case(issue_date='${endDate}', declared_construction_value, true, 0))/sum(case(issue_date='${startDate}', declared_construction_value, true, 0)) - 1), 0)) as mon_value_change_pct, sum(case(date_extract_y(issue_date)=date_extract_y('${endDate}'),declared_construction_value,true,0)) as curr_ytd_value, sum(case(date_extract_y(issue_date)=date_extract_y('${startDate}'),declared_construction_value,true,0)) as prev_ytd_value, case(sum(case(date_extract_y(issue_date)=date_extract_y('${startDate}'),declared_construction_value,true,0))=0,0,true,round(100*(sum(case(date_extract_y(issue_date)=date_extract_y('${endDate}'), declared_construction_value, true, 0))/sum(case(date_extract_y(issue_date)=date_extract_y('${startDate}'), declared_construction_value, true, 0)) - 1), 0)) as prev_ytd_value_change_pct, sum(case(issue_date='${endDate}',permit_count,true,0)) as curr_mon_permit_total, sum(case(issue_date='${startDate}',permit_count,true,0)) as prev_mon_permit_total, case(sum(case(issue_date='${startDate}',permit_count,true,0))=0,0,true,round(100*(sum(case(issue_date='${endDate}', permit_count, true, 0))/sum(case(issue_date='${startDate}', permit_count, true, 0)) - 1), 0)) as mon_permit_total_change_pct, sum(case(date_extract_y(issue_date)=date_extract_y('${endDate}'),permit_count,true,0)) as curr_ytd_permit_total, sum(case(date_extract_y(issue_date)=date_extract_y('${startDate}'),permit_count,true,0)) as prev_ytd_permit_total, case(sum(case(date_extract_y(issue_date)=date_extract_y('${startDate}'),permit_count,true,0))=0,0,true,round(100*(sum(case(date_extract_y(issue_date)=date_extract_y('${endDate}'), permit_count, true, 0))/sum(case(date_extract_y(issue_date)=date_extract_y('${startDate}'), permit_count, true, 0)) - 1), 0)) as ytd_permit_total_change_pct&$where=(issue_date between date_trunc_y('${endDate}') and '${endDate}' or issue_date between date_trunc_y('${startDate}') and '${startDate}')&$group=residential_category,building_type`
      );
      // By Residential Category
      const request04 = axios.get(
        `${this.$PERMIT_API}?$select=residential_category, sum(case(issue_date='${endDate}',declared_construction_value,true,0)) as curr_mon_value, sum(case(issue_date='${startDate}',declared_construction_value,true,0)) as prev_mon_value, case(sum(case(issue_date='${startDate}',declared_construction_value,true,0))=0,0,true,round(100*(sum(case(issue_date='${endDate}', declared_construction_value, true, 0))/sum(case(issue_date='${startDate}', declared_construction_value, true, 0)) - 1), 0)) as mon_value_change_pct, sum(case(date_extract_y(issue_date)=date_extract_y('${endDate}'),declared_construction_value,true,0)) as curr_ytd_value, sum(case(date_extract_y(issue_date)=date_extract_y('${startDate}'),declared_construction_value,true,0)) as prev_ytd_value, case(sum(case(date_extract_y(issue_date)=date_extract_y('${startDate}'),declared_construction_value,true,0))=0,0,true,round(100*(sum(case(date_extract_y(issue_date)=date_extract_y('${endDate}'), declared_construction_value, true, 0))/sum(case(date_extract_y(issue_date)=date_extract_y('${startDate}'), declared_construction_value, true, 0)) - 1), 0)) as prev_ytd_value_change_pct, sum(case(issue_date='${endDate}',permit_count,true,0)) as curr_mon_permit_total, sum(case(issue_date='${startDate}',permit_count,true,0)) as prev_mon_permit_total, case(sum(case(issue_date='${startDate}',permit_count,true,0))=0,0,true,round(100*(sum(case(issue_date='${endDate}', permit_count, true, 0))/sum(case(issue_date='${startDate}', permit_count, true, 0)) - 1), 0)) as mon_permit_total_change_pct, sum(case(date_extract_y(issue_date)=date_extract_y('${endDate}'),permit_count,true,0)) as curr_ytd_permit_total, sum(case(date_extract_y(issue_date)=date_extract_y('${startDate}'),permit_count,true,0)) as prev_ytd_permit_total, case(sum(case(date_extract_y(issue_date)=date_extract_y('${startDate}'),permit_count,true,0))=0,0,true,round(100*(sum(case(date_extract_y(issue_date)=date_extract_y('${endDate}'), permit_count, true, 0))/sum(case(date_extract_y(issue_date)=date_extract_y('${startDate}'), permit_count, true, 0)) - 1), 0)) as ytd_permit_total_change_pct&$where=(issue_date between date_trunc_y('${endDate}') and '${endDate}' or issue_date between date_trunc_y('${startDate}') and '${startDate}')&$group=residential_category`
      );
      // Total
      const request05 = axios.get(
        `${this.$PERMIT_API}?$select=sum(case(issue_date='${endDate}',declared_construction_value,true,0)) as curr_mon_value, sum(case(issue_date='${startDate}',declared_construction_value,true,0)) as prev_mon_value, case(sum(case(issue_date='${startDate}',declared_construction_value,true,0))=0,0,true,round(100*(sum(case(issue_date='${endDate}', declared_construction_value, true, 0))/sum(case(issue_date='${startDate}', declared_construction_value, true, 0)) - 1), 0)) as mon_value_change_pct, sum(case(date_extract_y(issue_date)=date_extract_y('${endDate}'),declared_construction_value,true,0)) as curr_ytd_value, sum(case(date_extract_y(issue_date)=date_extract_y('${startDate}'),declared_construction_value,true,0)) as prev_ytd_value, case(sum(case(date_extract_y(issue_date)=date_extract_y('${startDate}'),declared_construction_value,true,0))=0,0,true,round(100*(sum(case(date_extract_y(issue_date)=date_extract_y('${endDate}'), declared_construction_value, true, 0))/sum(case(date_extract_y(issue_date)=date_extract_y('${startDate}'), declared_construction_value, true, 0)) - 1), 0)) as prev_ytd_value_change_pct, sum(case(issue_date='${endDate}',permit_count,true,0)) as curr_mon_permit_total, sum(case(issue_date='${startDate}',permit_count,true,0)) as prev_mon_permit_total, case(sum(case(issue_date='${startDate}',permit_count,true,0))=0,0,true,round(100*(sum(case(issue_date='${endDate}', permit_count, true, 0))/sum(case(issue_date='${startDate}', permit_count, true, 0)) - 1), 0)) as mon_permit_total_change_pct, sum(case(date_extract_y(issue_date)=date_extract_y('${endDate}'),permit_count,true,0)) as curr_ytd_permit_total, sum(case(date_extract_y(issue_date)=date_extract_y('${startDate}'),permit_count,true,0)) as prev_ytd_permit_total, case(sum(case(date_extract_y(issue_date)=date_extract_y('${startDate}'),permit_count,true,0))=0,0,true,round(100*(sum(case(date_extract_y(issue_date)=date_extract_y('${endDate}'), permit_count, true, 0))/sum(case(date_extract_y(issue_date)=date_extract_y('${startDate}'), permit_count, true, 0)) - 1), 0)) as ytd_permit_total_change_pct&$where=(issue_date between date_trunc_y('${endDate}') and '${endDate}' or issue_date between date_trunc_y('${startDate}') and '${startDate}')`
      );

      const self = this;
      axios
        .all([
          request03,
          request04,
          request05,
        ])
        .then(
          axios.spread(function (
            response03,
            response04,
            response05,
          ) {
            self.response03 = response03.data;
            self.response04 = response04.data;
            self.response05 = response05.data;
          })
        );
    }
  },

  computed: {
    lastYear() {
      return parseInt(this.curYear) - 1;
    },

    defaultTotal() {
      return {
        curr_mon_permit_total: "",
        curr_mon_value: "",
        curr_ytd_permit_total: "",
        curr_ytd_value: "",
        mon_permit_total_change_pct: "",
        mon_value_change_pct: "",
        prev_mon_permit_total: "",
        prev_mon_value: "",
        prev_ytd_permit_total: "",
        prev_ytd_value: "",
        prev_ytd_value_change_pct: "",
        ytd_permit_total_change_pct: "",
      };
    },

    defaultTotalRes() {
      return {
        ...this.defaultTotal,
        residential_category: "Residential",
      };
    },

    defaultTotalNonRes() {
      return {
        ...this.defaultTotal,
        residential_category: "Non-Residential",
      };
    },

    residentials: function () {
      if (this.response03.length === 0) return [];
      return this.response03.filter(
        (res) => res.residential_category === "Residential"
      );
    },
    nonResidentials: function () {
      if (this.response03.length === 0) return [];
      return this.response03.filter(
        (res) => res.residential_category === "Non-Residential"
      );
    },
    totalRes: function () {
      if (this.response04.length === 0) return this.defaultTotalRes;
      const record = this.response04.find(
        (item) => item.residential_category === "Residential"
      );
      return record || this.defaultTotalRes;
    },
    totalNonRes: function () {
      if (this.response04.length === 0) return this.defaultTotalNonRes;
      const record = this.response04.find(
        (item) => item.residential_category === "Non-Residential"
      );
      return record || this.defaultTotalNonRes;
    },
    total: function () {
      if (this.response05.length === 0) return this.defaultTotal;
      return this.response05[0];
    },
  },
};
</script>

<style>
td {
  text-align: right;
}
</style>
